import { GET_WEBHOOKS, GET_SPECIFIC_WEBHOOK, GET_ALL_ROUTES, GET_ALL_QUEUES, GET_ALL_AGENTS, LISTAR_GRUPOS_DE_ROTAS } from './mutation-types'

import webhookHttpServices from '../_services/webhookHttpServices'

export default {
  listarWebhooks: async ({ commit }) => {
    try {
      const response = await webhookHttpServices.getWebhooks()
      commit(GET_WEBHOOKS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarWebhookEspecifico: async ({ commit }, id) => {
    try {
      const response = await webhookHttpServices.getWebhook(id)
      commit(GET_SPECIFIC_WEBHOOK, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarRotas: async ({ commit }) => {
    try {
      const response = await webhookHttpServices.getRotas()
      commit(GET_ALL_ROUTES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarFilas: async ({ commit }) => {
    try {
      const response = await webhookHttpServices.getFilas()
      commit(GET_ALL_QUEUES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarOperadores: async ({ commit }) => {
    try {
      const response = await webhookHttpServices.getOperadores()
      commit(GET_ALL_AGENTS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGruposDeRotas: async ({ commit }) => {
    try {
      const response = await webhookHttpServices.getGruposDeRotas()
      commit(LISTAR_GRUPOS_DE_ROTAS, response.data)
    } catch(e) {
      console.log(e)
    }
  },
}
